<template>
    <div v-if="visible" class="mc-root team-status">
        <v-btn text small class="team-status__button" :title="label"
            aria-haspopup="dialog" :aria-expanded="String(opened)" @click="open">
            <v-icon small>mdi-account-group-outline</v-icon>
            <strong class="team-status__compact t-caption" aria-hidden="true">{{ error ? '!' : teamCount(data) }}</strong>
            <span class="team-status__summary">
                <strong>{{ summaryText }}</strong>
                <span v-if="idleText" class="team-status__idle">{{ idleText }}</span>
            </span>
        </v-btn>
        <v-dialog v-model="opened" :fullscreen="$vuetify.breakpoint.xsOnly" max-width="1040" scrollable>
            <team-status-panel v-if="opened" :data="data" :loading="loading" :error="error" @refresh="refresh" @close="opened = false" />
        </v-dialog>
    </div>
</template>
<script>
import TeamStatusPanel from "./TeamStatusPanel.vue";
import { idleTime, summary, teamCount, validTeam } from "./model.mjs";
import "./team-status.css";
export default {
    name: "TeamStatus",
    components: { TeamStatusPanel },
    data: () => ({ data: null, loading: false, error: "", opened: false, denied: false, generation: 0 }),
    computed: {
        identity() { return `${this.$store.getters.userdata?.user_id}:${this.$store.getters.userdata?.username}:${this.$store.getters.token}`; },
        visible() { return !this.denied && (this.data?.applicable || Boolean(this.error)); },
        summaryText() { return this.error ? 'Team !' : this.loading && !this.data ? 'Team…' : summary(this.data); },
        idleText() {
            if (this.error || !this.data) return '';
            const person = this.data.fermo_piu_lungo;
            return person ? `Fermo: ${person.nome} · ${idleTime(person, this.data.aggiornato_il)}` : this.data.non_valutabili ? 'Dati incompleti' : '';
        },
        label() {
            return `${this.summaryText}${this.idleText ? ' ' + this.idleText : ''}. Il mio team: ${this.error ? 'dati non aggiornati. Apri per riprovare.' : 'apri i dettagli di oggi.'}`;
        },
    },
    watch: {
        identity() { this.generation++; this.data = null; this.error = ""; this.opened = false; this.denied = false; this.loading = false; this.refresh(); },
    },
    mounted() {
        this.refresh();
        // Badge readings have no authenticated team event: slow fallback while visible.
        this.timer = setInterval(this.refresh, 120000);
        this.onVisibility = () => { if (!document.hidden) this.refresh(); };
        document.addEventListener("visibilitychange", this.onVisibility);
    },
    beforeDestroy() { this.generation++; clearInterval(this.timer); document.removeEventListener("visibilitychange", this.onVisibility); },
    methods: {
        idleTime, summary, teamCount,
        open() { this.opened = true; this.refresh(); },
        async refresh() {
            if (this.loading || document.hidden || !this.$store.getters.isLoggedIn) return;
            const generation = this.generation;
            this.loading = true;
            try {
                const response = await this.$work.get("/teamleader/mio-team/oggi/", {}, true);
                if (generation !== this.generation) return;
                if (!validTeam(response?.data)) throw new Error("Risposta incompleta");
                this.data = response.data; this.error = ""; this.denied = false;
                if (!this.data.applicable) this.opened = false;
            } catch (error) {
                if (generation !== this.generation) return;
                if ([401, 403].includes(error?.response?.status)) {
                    this.denied = true; this.data = null; this.error = ""; this.opened = false;
                } else this.error = "Impossibile aggiornare il team. I dati precedenti non descrivono la situazione attuale.";
            } finally { if (generation === this.generation) this.loading = false; }
        },
    },
};
</script>
